// extracted by mini-css-extract-plugin
export default {"innerWrapper":"az-z","tooltipWrapper":"bz-z","icon":"cz-z","tooltip":"dz-z","content":"ez-z"};